import { isEmpty } from 'lodash'
import { defaultExportMenu } from '../helpers'

export default ({ config, data }) => {
  const { customMap, exportingMenu } = config

  const configuration = {
    type: 'MapChart',
    geodata: customMap,
    data,
    series: [
      {
        type: 'MapPolygonSeries',
        useGeodata: true,
        mapPolygons: {
          tooltipText: '{name}',
          fill: '#42be65', // map color
          states: {
            hover: {
              properties: {
                fill: '#24a148',
                stroke: '#9f1853'
              }
            }
          }
        }
      },
      {
        type: 'MapImageSeries',
        mapImages: {
          template: {
            tooltipText: '{title}',
            nonScaling: true,
            fill: '#000000',
            children: [
              {
                type: 'CircleBullet',
                circle: {
                  strokeWidth: 1,
                  propertyFields: {
                    radius: 'radius',
                    fill: 'fill',
                    stroke: 'stroke'
                  }
                },
                states: {
                  hover: {
                    properties: {
                      fill: 'red',
                      stroke: '#9f1853'
                    }
                  }
                }
              },
              {
                type: 'Label',
                text: '{value}',
                fill: '#fff',
                verticalCenter: 'middle',
                horizontalCenter: 'middle'
              }
            ],
            propertyFields: {
              latitude: 'latitude',
              longitude: 'longitude'
            }
          }
        }
      }
    ]
  }

  // Export menu
  if (exportingMenu && exportingMenu.enabled) {
    if (isEmpty(exportingMenu.config)) {
      configuration.exporting = defaultExportMenu
    } else {
      configuration.exporting = exportingMenu.config
    }
  }

  return configuration
}
